<template>
  <el-dialog
    v-el-drag-dialog
    :visible.sync="innerVisible"
    :title="$t('SystemMaintenance.SetOpInstruction')"
    width="1000px"
    :close-on-click-modal="false"
    class="details-view"
    style="overflow: auto;"
  >
    <div class="main-content" style="height: 455px;overflow: auto;">
      <el-form label-width="100px" style="width: 502px;">
        <el-form-item :label="$t('SystemMaintenance.CommandApplication')">
          <div style="width: 100%;display: flex; align-items: center;">
            <el-checkbox v-model="instructionManage.useHqSet" :disabled="readonly" style="margin-right: 5px" @change="onUseHqSet" />
            <span>{{ $t('CargoMsg.Cargo_GeneralSettings') }}</span>
            <i v-if="!formDisabale" style="color: #42b983;cursor: pointer;font-size: 18px;margin-left: auto;margin-right: 20px" class="el-icon-circle-plus" @click="add" />
          </div>
        </el-form-item>
      </el-form>
      <div v-for="(item, index) in instructionList" :key="getKey(instructionList.length, index)" style="margin-top: 15px;">
        <div style="display: flex;">
          <el-form :disabled="formDisabale" label-width="100px" style="width: 502px;">
            <el-form-item :key="'selectInstruction' + getKey(instructionList.length, index)">
              <span slot="label" class="title" style="font-size: 12px;">{{ $t('CargoMsg.Cargo_SelectInstruction') }}</span>
              <div style="width: 100%;display: flex; align-items: center;">
                <!--  选择租户操作指令弹窗  -->
                <tenant-instruction-dialog
                  input-width="100%"
                  :lob="lob"
                  :is-apply-ui-custom="true"
                  :value="item.tenantInstructionUuid"
                  :tenant-instructions="tenantInstructions"
                  style="width: 350px"
                  @change="p => tenantInstructionChange(p, item)"
                />
                <i v-if="!formDisabale" style="color: #f56c6c;cursor: pointer;font-size: 18px;margin-left: auto;margin-right: 20px;" class="el-icon-remove" @click="remove(item)" />
              </div>
            </el-form-item>
            <el-form-item :key="'commandParameters' + getKey(instructionList.length, index)" :label="$t('SystemMaintenance.CommandParameters')">
              <el-input v-model="item.instructionParam" type="textarea" :rows="3" style="width: 350px;" />
            </el-form-item>
            <el-form-item :key="'SceneRules' + getKey(instructionList.length, index)" :label="$t('SystemMaintenance.SceneRules')">
              <!--  选择特定业务规则弹窗  -->
              <specific-business-rule-dialog
                input-width="100%"
                :lob="lob"
                :apply-ui-custom="true"
                :specific-business-rule-uuid="item.specificBusinessRuleUuid"
                :specific-business-rules="specificBusinessRules"
                style="width: 350px"
                @change="p => specificBusinessRuleChange(p, item)"
              />
            </el-form-item>
            <el-form-item :key="'sceneParameters' + getKey(instructionList.length, index)" :label="$t('SystemMaintenance.SceneParameters')">
              <el-input v-model="item.ruleParam" type="textarea" :rows="3" style="width: 350px;" />
            </el-form-item>
          </el-form>
          <el-form :disabled="formDisabale" label-width="80px" label-position="left" style="flex-grow: 1;margin-right: 20px;">
            <el-form-item :key="'permission' + getKey(instructionList.length, index)">
              <span slot="label" class="title" style="font-size: 12px;">{{ $t('SystemMaintenance.InstructionPermissions') }}</span>
            </el-form-item>
            <el-form-item :key="'allPosition' + getKey(instructionList.length, index)" label-width="0" style="margin-left: 15px;">
              <el-checkbox v-model="item.instructionPermissionJson.allPosition" @change="onAllPositionChange(item)">{{ $t('SystemMaintenance.AllPositions2') }}</el-checkbox>
            </el-form-item>
            <el-form-item :key="'position' + getKey(instructionList.length, index)" :label="$t('SystemMaintenance.DesignatedPosition')" style="margin-left: 15px;">
              <cargo-advance-select
                :disabled="item.instructionPermissionJson.allPosition"
                callback-method-type="value"
                multiple
                :default-multiple-value="toArray(item.instructionPermissionJson.multipleSpecifiedPosition)"
                filterable
                :static-options="positionOptions"
                tag-name="label"
                tag-value="positionField"
                :filter-tag-names="['positionField', 'label']"
                @parentCallBack="value=>{item.instructionPermissionJson.multipleSpecifiedPosition=toTxt(value)}"
              />
            </el-form-item>
            <el-form-item :key="'person' + getKey(instructionList.length, index)" :label="$t('CargoMsg.Cargo_DesignatedPersonnel')" style="margin-left: 15px;">
              <cargo-advance-select
                :select-type="TYPE_NAMES.basic_data_User"
                callback-method-type="value"
                multiple
                :default-multiple-value="toNumArray(item.multipleSpecifiedPerson)"
                filterable
                @parentCallBack="value=>{item.multipleSpecifiedPerson=toTxt(value)}"
              />
            </el-form-item>
          </el-form>
        </div>
        <div v-if="index < instructionList.length - 1" class="el-divider el-divider--horizontal" style="margin: 10px 0 0 10px;width: calc(100% - 25px);" />
      </div>
    </div>
    <span slot="footer">
      <el-button type="primary" @click="okHandler">{{ $t('Message.Confirm') }}</el-button>
      <el-button @click="innerVisible=false">{{ $t('Message.Cancel') }}</el-button>
    </span>
  </el-dialog>
</template>

<script>
import TenantInstructionDialog from '@/views/cargo/v0/SystemMaintenance/components/basicConfig/tenantInstructionDialog'
import SpecificBusinessRuleDialog from '@/views/cargo/v0/SystemMaintenance/components/basicConfig/specificBusinessRuleDialog'
import { getInstructionManage, saveInstructionManage, getLobPositionList } from '@/api/sysManage/uiCustom'
import { getLoading4Cxt } from '@/utils/utilBaseElement'
import CargoAdvanceSelect from '@/components/Cargo/Common/cargoAdvanceSelect'
import { TYPE_NAMES } from '@/utils/class/AdvanceSelect'
import * as UICustomConstants from '@/class/cargo/model/parameters/UICustomConstants'

export default {
  name: 'InstructionSetDialog',
  components: { TenantInstructionDialog, SpecificBusinessRuleDialog, CargoAdvanceSelect },
  props: {
    visible: { type: Boolean, required: true },
    module: { type: Number, required: true },
    pageType: { type: Number, required: true },
    branchId: { type: Number, required: true },
    lob: { type: String, required: true },
    tenantInstructions: { type: Array, required: true },
    specificBusinessRules: { type: Array, required: true },
    useHqSet: { type: Boolean, required: true },
    readonly: { type: Boolean, default: false }
  },
  data() {
    return {
      innerVisible: false,
      TYPE_NAMES,
      instructionManage: {},
      hqInstructionList: null,
      instructionList: [],
      deletedInstructionKeys: [],
      positionOptions: []
    }
  },
  computed: {
    // 是否禁用表单
    formDisabale() {
      return this.readonly || (this.branchId !== 1 && this.instructionManage.useHqSet)
    }
  },
  watch: {
    visible: {
      immediate: true,
      async handler(newVal) {
        this.innerVisible = newVal
        if (newVal) {
          getLobPositionList({ lob: this.lob }).then(res => {
            this.positionOptions = res.data
          })
          const params = { module: this.module, pageType: this.pageType, branchId: this.branchId, useHqSet: this.useHqSet }
          if (this.module === UICustomConstants.RAILWAY_BOOKING_MODULE) {
            params.lob = this.lob
          }
          this.instructionManage = await getInstructionManage(params).then(res => {
            const data = res.data
            this.toAnalysisInstructionListPermission(data.hqUiCustomInstructions)
            this.toAnalysisInstructionListPermission(data.uiCustomInstructions)
            return data
          })
          this.hqInstructionList = this.instructionManage.hqUiCustomInstructions || null
          this.instructionList = this.instructionManage.uiCustomInstructions
          this.onUseHqSet()
        }
      }
    },
    innerVisible(newVal) {
      this.$emit('update:visible', newVal)
      if (!newVal) {
        this.instructionManage = { useHqSet: false }
        this.hqInstructionList = null
        this.instructionList = []
        this.deletedInstructionKeys = []
      }
    }
  },
  methods: {
    onUseHqSet() {
      if (this.branchId === 1) {
        return
      }
      if (this.instructionManage.useHqSet) {
        for (const item of this.instructionList) {
          if (item.uuid) {
            this.deletedInstructionKeys.push(item.uuid)
          }
        }
        this.instructionList = Array.from(this.hqInstructionList, p => {
          return {
            instructionManageUuid: '',
            tenantInstructionUuid: p.tenantInstructionUuid,
            instructionParam: p.instructionParam,
            specificBusinessRuleUuid: p.specificBusinessRuleUuid,
            ruleParam: p.ruleParam,
            instructionPermissionContent: p.instructionPermissionContent,
            instructionPermissionJson: p.instructionPermissionJson,
            multipleSpecifiedPerson: p.multipleSpecifiedPerson
          }
        })
      }
    },
    // 解析指令列表权限
    toAnalysisInstructionListPermission(instructionList) {
      if (!instructionList) {
        return
      }
      for (const item of instructionList) {
        item.instructionPermissionJson = this.toAnalysisPermissionContent(item.instructionPermissionContent)
      }
    },
    // 解析权限内容
    toAnalysisPermissionContent(permissionContent) {
      if (!permissionContent) {
        return { allPosition: true, multipleSpecifiedPosition: '' }
      }
      return JSON.parse(permissionContent)
    },
    add() {
      this.instructionList.push({
        instructionManageUuid: '',
        tenantInstructionUuid: '',
        instructionParam: '',
        specificBusinessRuleUuid: '',
        ruleParam: '',
        instructionPermissionContent: '',
        instructionPermissionJson: { allPosition: true, multipleSpecifiedPosition: '' },
        multipleSpecifiedPerson: ''
      })
    },
    remove(item) {
      if (item.uuid) {
        this.deletedInstructionKeys.push(item.uuid)
      }
      this.instructionList = this.instructionList.filter(p => p !== item)
    },
    // 选择租户操作指令
    tenantInstructionChange(data, form) {
      if (data) {
        form.tenantInstructionUuid = data.uuid
      } else {
        form.tenantInstructionUuid = ''
      }
    },
    // 选择特定业务规则
    specificBusinessRuleChange(data, form) {
      if (data) {
        form.specificBusinessRuleUuid = data.uuid
      } else {
        form.specificBusinessRuleUuid = ''
      }
    },
    okHandler() {
      if (this.readonly) {
        this.innerVisible = false
        return
      }
      let instructionList = this.instructionList
      if (this.instructionManage.useHqSet && this.branchId !== 1) {
        for (const item of instructionList) {
          if (item.uuid) {
            this.deletedInstructionKeys.push(item.uuid)
          }
        }
        instructionList = []
      } else {
        for (const item of instructionList) {
          if (!item.tenantInstructionUuid) {
            this.$message.warning(this.$t('SystemMaintenance.PleaseCommandForAScenario'))
            return
          }
          let allPosition = true
          let multipleSpecifiedPosition = ''
          if (item.instructionPermissionJson) {
            item.instructionPermissionContent = JSON.stringify(item.instructionPermissionJson)
            allPosition = item.instructionPermissionJson.allPosition
            multipleSpecifiedPosition = item.instructionPermissionJson.multipleSpecifiedPosition
          }
          if (!allPosition && !multipleSpecifiedPosition && !item.multipleSpecifiedPerson) {
            this.$message.warning(this.$t('SystemMaintenance.PleaseAPositionOrPersonnel'))
            return
          }
        }
      }
      const loading = getLoading4Cxt(this)
      saveInstructionManage({
        ...this.instructionManage,
        hqUiCustomInstructions: null,
        uiCustomInstructions: instructionList,
        deletedInstructionKeys: this.deletedInstructionKeys
      }).then(() => {
        this.$message.success(this.$t('Message.SaveSuccessfully'))
        this.innerVisible = false
      }).finally(() => {
        loading.close()
      })
    },
    getKey(total, index) {
      return total * total + index
    },
    toArray(txt) {
      if (txt) {
        return Array.from(txt.split(','), p => p)
      }
      return []
    },
    toNumArray(txt) {
      if (txt) {
        return Array.from(txt.split(','), p => Number(p))
      }
      return []
    },
    toTxt(strs) {
      if (strs && strs.length > 0) {
        return strs.join(',')
      }
      return ''
    },
    onAllPositionChange(item) {
      if (item.instructionPermissionJson.allPosition) {
        item.instructionPermissionJson.multipleSpecifiedPosition = ''
      }
    }
  }
}
</script>
